import gql from 'graphql-tag';
import ShippingMethodAllFragment from '../fragments/ShippingMethodAllFragment';

export default gql`
query AdminShippingMethodsList {
    adminShippingMethods {
        ...ShippingMethodAllFragment
    }
}
${ShippingMethodAllFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminShippingMethods.ts